import React from "react";
import { whatsapp } from "../mock";
import { useLang } from "../i18n";
import { track } from "../analytics";

// Build a wa.me click-to-chat URL with an optional prefilled message
export const waLink = (message) =>
  `https://wa.me/${whatsapp.number}?text=${encodeURIComponent(
    message || "Hello Tele-Comp Solutions!"
  )}`;

// Official WhatsApp glyph (used for click-to-chat buttons)
export const WhatsAppIcon = ({ className = "w-6 h-6" }) => (
  <svg
    viewBox="0 0 32 32"
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M16.04 4C9.96 4 5.02 8.94 5.02 15.02c0 1.95.51 3.84 1.48 5.51L4.9 27.1l6.74-1.77a11 11 0 0 0 4.4.92h.01c6.08 0 11.02-4.94 11.02-11.02C27.07 8.94 22.12 4 16.04 4Zm0 20.18h-.01a9.13 9.13 0 0 1-4.65-1.27l-.33-.2-3.99 1.05 1.06-3.89-.22-.34a9.1 9.1 0 0 1-1.4-4.84c0-5.04 4.1-9.14 9.15-9.14 2.44 0 4.74.95 6.47 2.68a9.1 9.1 0 0 1 2.68 6.47c0 5.05-4.1 9.15-9.13 9.15Zm5.02-6.85c-.27-.14-1.63-.8-1.88-.9-.25-.09-.43-.13-.62.14-.18.27-.71.9-.87 1.08-.16.18-.32.2-.59.07-.27-.14-1.16-.43-2.21-1.36-.82-.73-1.37-1.63-1.53-1.9-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.46.09-.18.05-.34-.02-.48-.07-.14-.62-1.49-.85-2.04-.22-.53-.45-.46-.62-.47l-.53-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.98 2.66 1.12 2.84.14.18 1.94 2.96 4.7 4.15.66.28 1.17.45 1.57.58.66.21 1.26.18 1.74.11.53-.08 1.63-.67 1.86-1.31.23-.64.23-1.19.16-1.31-.07-.12-.25-.18-.52-.32Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
    <a
      href={waLink(t.whatsapp.defaultMessage)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.chatWith}
      onClick={() => track("whatsapp_click", { label: "float" })}
      className="fixed bottom-6 right-6 z-[100] flex items-center gap-2 px-5 py-3.5 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white font-bold shadow-xl hover:-translate-y-0.5 transition-all"
    >
      <WhatsAppIcon className="w-6 h-6" />
      <span className="hidden sm:inline">{t.whatsapp.chatWith}</span>
    </a>
  );
};
